// extracted by mini-css-extract-plugin
module.exports = {"link":"MortgageInsuranceCard_link__Z8uIn","card":"MortgageInsuranceCard_card__tw_RE","badge":"MortgageInsuranceCard_badge__4q5oO","img":"MortgageInsuranceCard_img__xmo_Z"};